(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  const updateNewsletterButton = (input) => {
    const form = input.closest('.footer__newsletter');
    const button = form?.querySelector('.footer__newsletter-button');

    if (!button) return;

    const isSuccessful = input.hasAttribute('data-newsletter-success');
    const isSubmitting = form.getAttribute('aria-busy') === 'true';
    const isValid = !isSuccessful && input.checkValidity();
    const isDisabled = isSubmitting || !isValid;

    button.disabled = isDisabled;
  };

  const initializeNewsletterForms = (root = document) => {
    root.querySelectorAll('.footer__newsletter-input').forEach(updateNewsletterButton);
  };

  const clearNewsletterSubmissionParameters = () => {
    if (!document.querySelector('.footer__newsletter-input[data-newsletter-success]')) return;

    const url = new URL(window.location.href);
    const submissionParameters = ['customer_posted', 'contact_posted'];
    const originalSearch = url.search;

    submissionParameters.forEach((parameter) => url.searchParams.delete(parameter));

    if (url.search === originalSearch) return;

    window.history.replaceState(window.history.state, '', url);
  };

  const handleNewsletterInput = (event) => {
    if (event.target.matches('.footer__newsletter-input')) {
      updateNewsletterButton(event.target);
    }
  };

  ['input', 'change'].forEach((eventName) => document.addEventListener(eventName, handleNewsletterInput));

  document.addEventListener('submit', (event) => {
    if (!event.target.matches('.footer__newsletter')) return;

    const form = event.target;
    const input = form.querySelector('.footer__newsletter-input');
    const button = form.querySelector('.footer__newsletter-button');

    if (!input || !button || !input.checkValidity()) return;

    form.setAttribute('aria-busy', 'true');
    button.disabled = true;
  });

  document.addEventListener('shopify:section:load', (event) => {
    initializeNewsletterForms(event.target);
  });

  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;

    initializeNewsletterForms();
    clearNewsletterSubmissionParameters();
  });

  initializeNewsletterForms();
  clearNewsletterSubmissionParameters();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('sticky-header')) {
    class StickyHeader extends HTMLElement {
      connectedCallback() {
        this.header = this.closest('.section-header');
        if (!this.header) return;

        this.currentScrollTop = 0;
        this.onScrollHandler = this.onScroll.bind(this);
        this.shopAnchorLoading = document.documentElement.classList.contains('shop-anchor-load');
        this.finishShopAnchorLoad = () => {
          this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
          this.setLogoHidden(true);
          this.shopAnchorLoading = false;
          this.shopAnchorTarget = null;
          document.documentElement.classList.remove('shop-anchor-load');
        };
        this.handleShopAnchorLoad = () => this.beginShopAnchorNavigation(true);

        this.setHeaderHeight();
        this.headerLayout = window.matchMedia('(max-width: 899px)');
        this.onHeaderLayoutChange = () => this.setHeaderHeight();
        this.headerLayout.addEventListener('change', this.onHeaderLayoutChange);

        if (this.shopAnchorLoading) {
          this.setLogoHidden(true);

          if (document.readyState === 'complete') {
            this.handleShopAnchorLoad();
          } else {
            window.addEventListener('load', this.handleShopAnchorLoad, { once: true });
          }
        } else {
          this.setLogoHidden(false);
        }

        window.addEventListener('scroll', this.onScrollHandler, false);
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScrollHandler);
        window.removeEventListener('load', this.handleShopAnchorLoad);
        this.headerLayout?.removeEventListener('change', this.onHeaderLayoutChange);
      }

      beginShopAnchorNavigation(replaceHistory = false) {
        const target = document.getElementById('shop');
        if (!target) return this.finishShopAnchorLoad();

        this.shopAnchorLoading = true;
        this.shopAnchorTarget = target;
        this.setLogoHidden(true);

        if (window.location.hash !== '#shop') {
          const targetUrl = `${window.location.pathname}${window.location.search}#shop`;
          window.history[replaceHistory ? 'replaceState' : 'pushState'](null, '', targetUrl);
        }

        const hero = document.querySelector('[data-home-hero]');
        const heroImage = hero?.querySelector('img');
        const heroImageReady = heroImage?.decode ? heroImage.decode().catch(() => {}) : Promise.resolve();

        Promise.all([document.fonts.ready, heroImageReady]).then(() => {
          window.requestAnimationFrame(() => {
            if (window.matchMedia('(min-width: 900px)').matches) {
              hero?.style.setProperty('--hero-progress', '1');
            }

            this.alignShopAnchor();
            this.finishShopAnchorLoad();
          });
        });
      }

      alignShopAnchor() {
        if (!this.shopAnchorTarget) return;

        const pageInset =
          Number.parseFloat(window.getComputedStyle(document.documentElement).getPropertyValue('--page-inset')) || 0;
        const positionError = this.shopAnchorTarget.getBoundingClientRect().top - pageInset;

        if (Math.abs(positionError) > 0.5) {
          window.scrollBy(0, positionError);
        }
      }

      setHeaderHeight() {
        if (!this.header) return;
        const headerHeight = this.header.offsetHeight;
        document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
      }

      onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.shopAnchorLoading) {
          this.currentScrollTop = scrollTop;
          this.setLogoHidden(true);
          return;
        }

        if (scrollTop <= 0) {
          this.setLogoHidden(false);
        } else if (scrollTop > this.currentScrollTop) {
          this.setLogoHidden(true);
        } else if (scrollTop < this.currentScrollTop) {
          this.setLogoHidden(false);
        }

        this.currentScrollTop = scrollTop;
      }

      setLogoHidden(hidden) {
        this.header.classList.toggle('header-logo-inactive', hidden);
      }
    }

    customElements.define('sticky-header', StickyHeader);
  }

  document.addEventListener('click', (event) => {
    const shopLink = event.target.closest('a[href]');

    if (shopLink) {
      const targetUrl = new URL(shopLink.href, window.location.href);
      const isSamePageShopLink =
        targetUrl.origin === window.location.origin &&
        targetUrl.pathname === window.location.pathname &&
        targetUrl.hash === '#shop';

      if (isSamePageShopLink) {
        event.preventDefault();
        document.querySelector('sticky-header')?.beginShopAnchorNavigation();
      }
    }

    const closeButton = event.target.closest('[data-menu-close]');
    if (!closeButton) return;

    const details = closeButton.closest('.header__mobile-menu');
    if (!details) return;

    details.removeAttribute('open');
  });

  const initializeMobileMenus = () => {
    document.querySelectorAll('.header__mobile-menu').forEach((details) => {
      if (details.dataset.accessibilityReady === 'true') return;
      details.dataset.accessibilityReady = 'true';

      const summary = details.querySelector('summary');
      const panel = details.querySelector('.header__menu-overlay-panel');
      const closeButton = details.querySelector('.header__menu-overlay-close');
      if (!summary || !panel || !closeButton) return;

      let inertSiblings = [];

      details.addEventListener('toggle', () => {
        if (details.open) {
          inertSiblings = window.PureTheme?.setSiblingsInert(details, []) || [];
          window.requestAnimationFrame(() => closeButton.focus({ preventScroll: true }));
          return;
        }

        window.PureTheme?.restoreSiblingsInert(inertSiblings);
        inertSiblings = [];
        summary.focus({ preventScroll: true });
      });

      details.addEventListener('keydown', (event) => {
        if (!details.open) return;

        if (event.key === 'Escape') {
          event.preventDefault();
          details.removeAttribute('open');
          return;
        }

        window.PureTheme?.trapFocus(event, panel);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeMobileMenus, { once: true });
  } else {
    initializeMobileMenus();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-home-hero]').forEach((hero) => {
    if (hero.dataset.heroReady === 'true') return;
    hero.dataset.heroReady = 'true';

    const mobileMedia = window.matchMedia('(max-width: 899px)');
    const desktopTransitionDistance = 220;
    let frameId = 0;

    const clampProgress = (progress) => Math.max(0, Math.min(1, progress));

    const updateHero = () => {
      if (mobileMedia.matches) {
        hero.style.setProperty('--hero-progress', '0');
        return;
      }

      const progress = clampProgress(window.scrollY / desktopTransitionDistance);
      hero.style.setProperty('--hero-progress', progress.toFixed(3));
    };

    const requestUpdate = () => {
      if (mobileMedia.matches) return;
      cancelAnimationFrame(frameId);
      frameId = requestAnimationFrame(updateHero);
    };

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    mobileMedia.addEventListener('change', updateHero);
    updateHero();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["music-player"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('music-player')) {
    class MusicPlayer extends HTMLElement {
      connectedCallback() {
        if (this.isReady) return;
        this.isReady = true;

        this.audio = this.querySelector('[data-audio]');
        this.cover = this.querySelector('[data-current-cover]');
        this.nameElement = this.querySelector('[data-current-name]');
        this.artistElement = this.querySelector('[data-current-artist]');
        this.playButton = this.querySelector('[data-play-pause]');
        this.playIcon = this.querySelector('[data-play-icon]');
        this.pauseIcon = this.querySelector('[data-pause-icon]');
        this.previousButton = this.querySelector('[data-previous]');
        this.nextButton = this.querySelector('[data-next]');
        this.volumeButton = this.querySelector('[data-volume]');
        this.tracks = Array.from(this.querySelectorAll('[data-track]'))
          .map((track) => ({
            number: Number(track.dataset.trackNumber),
            src: track.dataset.src,
            name: track.dataset.name,
            artist: track.dataset.artist,
            image: track.dataset.image || '',
          }))
          .sort((trackA, trackB) => trackA.number - trackB.number);
        this.currentIndex = 0;
        this.volumePercent = Number(this.dataset.volumePercent) || 0;

        if (!this.audio || this.tracks.length === 0) return;

        this.previousButton.addEventListener('click', () => this.changeTrack(-1));
        this.nextButton.addEventListener('click', () => this.changeTrack(1));
        this.playButton.addEventListener('click', () => this.togglePlayback());
        this.volumeButton.addEventListener('click', () => {
          this.audio.muted = !this.audio.muted;
        });
        this.audio.addEventListener('play', () => this.updatePlaybackState());
        this.audio.addEventListener('pause', () => this.updatePlaybackState());
        this.audio.addEventListener('ended', () => this.changeTrack(1, true));
        this.audio.addEventListener('volumechange', () => this.updateVolumeState());

        this.renderTrack();
        this.updatePlaybackState();
        this.updateVolumeState();
      }

      renderTrack() {
        const track = this.tracks[this.currentIndex];
        const hasAudio = Boolean(track.src);

        this.nameElement.textContent = track.name;
        this.artistElement.textContent = track.artist;
        this.playButton.disabled = !hasAudio;

        if (track.image) {
          this.cover.src = track.image;
          this.cover.hidden = false;
        } else {
          this.cover.removeAttribute('src');
          this.cover.hidden = true;
        }

        if (hasAudio) {
          this.audio.src = track.src;
        } else {
          this.audio.removeAttribute('src');
        }
        this.audio.load();
      }

      changeTrack(direction, autoplay = false) {
        const wasPlaying = autoplay || !this.audio.paused;
        this.currentIndex = (this.currentIndex + direction + this.tracks.length) % this.tracks.length;
        this.renderTrack();

        if (wasPlaying && this.tracks[this.currentIndex].src) {
          this.audio.play().catch(() => this.updatePlaybackState());
        }
      }

      togglePlayback() {
        if (!this.tracks[this.currentIndex].src) return;

        if (this.audio.paused) {
          this.updatePlaybackState(true);

          try {
            this.ensureAudioGraph();
            this.resumeAudioContext();
            this.audio.play().catch(() => this.updatePlaybackState(false));
          } catch {
            this.updatePlaybackState(false);
          }
        } else {
          this.audio.pause();
          this.updatePlaybackState(false);
        }
      }

      ensureAudioGraph() {
        if (this.audioContext || !window.AudioContext) return;

        this.audioContext = new AudioContext();
        this.audioSource = this.audioContext.createMediaElementSource(this.audio);
        this.gainNode = this.audioContext.createGain();
        this.gainNode.gain.value = this.volumePercent / 100;
        this.audioSource.connect(this.gainNode);
        this.gainNode.connect(this.audioContext.destination);
      }

      resumeAudioContext() {
        if (this.audioContext?.state === 'suspended') {
          this.audioContext.resume();
        }
      }

      updatePlaybackState(isPlaying = !this.audio.paused) {
        this.playIcon.toggleAttribute('hidden', isPlaying);
        this.pauseIcon.toggleAttribute('hidden', !isPlaying);
        this.playButton.setAttribute('aria-label', isPlaying ? this.dataset.pauseLabel : this.dataset.playLabel);
      }

      updateVolumeState() {
        const isMuted = this.audio.muted || this.volumePercent === 0;
        this.volumeButton.classList.toggle('is-muted', isMuted);
        this.volumeButton.setAttribute('aria-label', isMuted ? this.dataset.unmuteLabel : this.dataset.muteLabel);
      }
    }

    customElements.define('music-player', MusicPlayer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-images"]) return;
  try {
    
  document.querySelectorAll('[data-product-carousel]').forEach((carousel) => {
    if (carousel.dataset.carouselReady === 'true') return;
    carousel.dataset.carouselReady = 'true';

    const track = carousel.querySelector('[data-product-carousel-track]');
    const slides = Array.from(carousel.querySelectorAll('[data-product-carousel-slide]'));
    const dots = Array.from(carousel.querySelectorAll('[data-product-carousel-dot]'));
    const mobileMedia = window.matchMedia('(max-width: 899px)');
    if (!track || slides.length < 2 || dots.length !== slides.length) return;

    const setActiveDot = (activeIndex) => {
      dots.forEach((dot, index) => {
        const isActive = index === activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    };

    const syncDots = () => {
      if (!mobileMedia.matches) {
        setActiveDot(0);
        return;
      }

      const slideWidth = track.clientWidth || 1;
      const activeIndex = Math.min(slides.length - 1, Math.max(0, Math.round(track.scrollLeft / slideWidth)));
      setActiveDot(activeIndex);
    };

    const syncCarousel = () => {
      syncDots();
    };

    let frameId = 0;

    track.addEventListener(
      'scroll',
      () => {
        cancelAnimationFrame(frameId);
        frameId = requestAnimationFrame(syncDots);
      },
      { passive: true }
    );

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        track.scrollTo({
          left: slides[index].offsetLeft,
          behavior: 'smooth',
        });
      });
    });

    window.addEventListener('resize', syncCarousel);
    syncCarousel();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  if (!customElements.get('product-details-panel')) {
    class ProductDetailsPanel extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('.product-details');
        this.header = document.querySelector('.section-header');
        this.desktopMedia = window.matchMedia('(min-width: 900px)');
        this.updateStickyState = this.updateStickyState.bind(this);
        this.resizeObserver = new ResizeObserver(this.updateStickyState);

        if (this.details) this.resizeObserver.observe(this.details);
        if (this.header) this.resizeObserver.observe(this.header);

        window.addEventListener('resize', this.updateStickyState);
        this.updateStickyState();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        window.removeEventListener('resize', this.updateStickyState);
      }

      updateStickyState() {
        if (!this.desktopMedia.matches || !this.details || !this.header) {
          this.classList.remove('is-sticky');
          this.style.removeProperty('--product-details-sticky-top');
          return;
        }

        const page = this.closest('.page-content--product');
        const pageTopPadding = page ? Number.parseFloat(getComputedStyle(page).paddingTop) : 0;
        const bottomGap = Number.parseFloat(getComputedStyle(this).getPropertyValue('--product-details-bottom-gap'));
        const defaultStickyTop = this.header.offsetHeight + pageTopPadding;
        const availableHeight = window.innerHeight - defaultStickyTop - bottomGap;
        const detailsHeight = this.details.getBoundingClientRect().height;
        const stickyTop = detailsHeight > availableHeight + 1
          ? window.innerHeight - detailsHeight - bottomGap
          : defaultStickyTop;

        this.style.setProperty('--product-details-sticky-top', `${stickyTop}px`);
        this.classList.add('is-sticky');
      }
    }

    customElements.define('product-details-panel', ProductDetailsPanel);
  }

  } catch(e) { console.error(e); }
})();
})();
